module.exports = __webpack_public_path__ + "img/shuchu0685.3278f5a4.png";